// Ace code editor

(function (__module__) {
  'use strict';

  var logger = c2.logging.getLogger(__module__);
  var langTools = ace.require("ace/ext/language_tools");
  var modelist = ace.require("ace/ext/modelist");
  var newline = String.fromCharCode(10);
  var powershellHeader = "# PowerShell doesn't need a shebang since CB'll append a .ps1 file extension.";
  var defaultLangs = [
    {caption: 'SH', name: 'sh'},
    {caption: 'Python', name: 'python'},
    {caption: 'Go', name: 'golang'},
    {caption: 'Perl', name: 'perl'},
    {caption: 'Powershell', name: 'powershell'},
    {caption: 'Ruby', name: 'ruby'}
  ];


    /**
     * Ajax call to send code edited inside an ace editor as POST. Takes the id for the hook, the id for the editor,
     * and the edited code.
     */
    function saveUpdatedCode(hook_id, editor_id, edited_code) {
        $.ajax({
            url: '/actions/' + hook_id + '/edit_code/',
            type: 'POST',
            data: {"file_content": edited_code},
            success: function (response) {
                //  Disable the "save code" button since code has already been saved
                $('#' + editor_id + '-save_button').attr("disabled", true);
                $('#' + editor_id + '-save_button').text("Saved!");
                //  Enable the "show out-out-of-box code" and "revert changes" buttons without refreshing page
                $('#' + editor_id + '-revert-code').removeClass("hidden");
                $('#' + editor_id + '-show_ootb_link').removeClass('disabled');
                $('#' + editor_id + '-show_ootb_link').css('cursor', 'pointer');
                $('#' + editor_id + '-show_ootb_link').off("click");
                $('#' + editor_id + '-show_ootb_link').click(function () {
                    c2.ace.toggleOotbCode('#action-source-code-' + editor_id)
                });
                $('#' + editor_id + '-show_ootb_link').attr('data-original-title', 'yourText');
                //  Confirm success
                c2.alerts.addGlobalAlert(response, 'success', true);
                // Now reload the action inputs, since they may have changed with changes to the action code
                c2.spinners.showSpinner({selector: "#action-inputs"})
                $( "#action-inputs" ).load("/actions/action_inputs_fragment/" + hook_id + "/", function() {
                  // Once the action inputs have loaded, make them sortable
                  c2.sortable.sortablePanels('#sequenced-action-inputs', "/actions/" + hook_id + "/resequence_action_inputs");
                });
            },
            error: function (jqXHR) {
                c2.alerts.addGlobalAlert(jqXHR.responseText, 'error', true);
            }
        });
    }


  /**
   * If a panel contains a textarea with class "ace-lg", an Ace editor will be
   * instantiated (but only once).
   */
  function initializeAceInPanel($panelBody) {
    var $textarea;

    $panelBody.find('textarea.ace-lg').each(function() {
      $textarea = $(this);

      // Only initialize Ace once
      if ($textarea.data('aceInitialized')) {
        return;
      }
      $textarea.data('aceInitialized', true);

      var editor_id = $textarea.attr('id');
      var hook_id = $textarea.attr('hook_id');
      var edited_code = null;


      //   * if there is a save button (which only happens if permissions are appropriate),
      //   * set up the event listeners to make the Ace editor options
        if ($('#' + editor_id + '-save_button').length > 0) {
            var editor = c2.ace.init(editor_id, {
                aceOptions: {
                    readOnly: false
                }
            });
          // * if code is editable, i.e. not the out-of-the-box comparison code,
          // *set up the ace dropdown language preferences and snippets
            if (editor_id.indexOf('ootb') == -1) {
                setupLanguages(editor)
                setupSnippets(editor)
            }
            // set up event listener that enables save button and updates edited_code if code is changed
            editor.on("change", function (e) {
                edited_code = editor.getValue();
                $('#' + editor_id + '-save_button').attr("disabled", false)
                $('#' + editor_id + '-save_button').text('Save Code')
            });
            //  "Save Code" button sends all necessary info the the saveUpdatedCode function
            $('#' + editor_id + '-save_button').click(function () {
                saveUpdatedCode(hook_id, editor_id, edited_code)
            })
        } else {
            c2.ace.init(editor_id, {
                aceOptions: {
                    readOnly: true
                }
            });
        }
    });
  }

  /* Initialize an editor
     editorID: required ID
     options:
         aceOptions: passed directly to Ace
           theme: string for the theme to use (default 'ace/theme/chrome', or 'ace/theme/monokai' in dark mode)
           language: initial language (default 'ace/mode/python')
         compact: if true, remove line numbers, gutter, etc.
         oneLine: constrain editor to one line; prevent newlines.
         cursorAtStart: bool, place cursor at start (default) or end of content
     initialContent: optional content. If not specified, contents of the editor
         element will be used.
  */
  function init(editorID, options, initialContent) {
    var baseId = editorID || 'editor';
    var $editor = $('#' + baseId);

    // If this element is already backed by a live Ace instance, return it
    // as-is rather than re-initializing. Bugfix for error where $editor.html() reads
    // Ace's own rendered internals. Honors an explicitly-passed
    // initialContent (as opposed to one scraped from the DOM)
    var existingEditor = $editor[0] && $editor[0].env && $editor[0].env.editor;
    if (existingEditor) {
      if (initialContent) {
        existingEditor.setValue(initialContent.trim(), 1);
      }
      return existingEditor;
    }

    // If $editor is a textarea or input field:
    var value_by_val = $editor.val && $editor.val();
    // If $editor is a non-form-field such as a div with no Ace instance yet,
    // e.g. server-rendered content dropped directly into the container:
    var value_by_html = $editor.html && $editor.html();
    initialContent = (initialContent || value_by_val || value_by_html || "").trim();
    options = options || {};
    var compactMode = options.compact || false;
    var oneLineMode = options.oneLine || false;
    var customFormat = options.customFormat;

    // Bool option defaults to true
    var cursorAtStart = (options.cursorAtStart === undefined) ? true : options.cursorAtStart;
    var cursorLoc = cursorAtStart ? -1 : 1;
    var isDarkMode = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    var aceOptions = _.defaults(options.aceOptions || {}, {
      enableBasicAutocompletion: true,
      mode: 'ace/mode/python',
      theme: isDarkMode ? 'ace/theme/monokai' : 'ace/theme/chrome',
      showPrintMargin: false
    });

    if (compactMode) {
      aceOptions.showPrintMargin = false;
      aceOptions.showGutter = false;
    }

    if (customFormat === 'json') {
      try {
        initialContent = JSON.stringify(JSON.parse(initialContent), null, 2)
      } catch {}  // if the parsing fails just leave the invalid value as-is
    }

    if (oneLineMode) {
      aceOptions.highlightActiveLine = false;
      // Remove new lines from initial content
      initialContent = initialContent.replace(/[\r\n]/g, '');
    }

    logger.debug('Initializing editor #'+baseId+' with aceOptions ', aceOptions);
    var editor = ace.edit(baseId);

    // Annotate the Ace editor object so other functions have access to these
    editor.id = baseId;
    editor.oneLineMode = oneLineMode;

    editor.setOptions(aceOptions);

    // Prevent deprecation warning message in console
    editor.$blockScrolling = Infinity;

    editor.setWrapBehavioursEnabled(false);

    if (oneLineMode) {
      // Set up a change handler that strips newlines as they're inserted
      // (by typing or pasting).  This must be set up before the `setValue`
      // call below which may introduce newlines too.
      editor.getSession().on('change', replaceNewlines(editor));
    }

    editor.setValue(initialContent, cursorLoc);

    return editor;
  }


  /* Return an event handler that essentially ignores newline characters typed
   * by the user.  The cursor goes to the end of the line if a newline is typed
   * anywhere.
   */
  function replaceNewlines(editor) {
    return function (e) {
      if (e.action == 'insert') {
        var val = editor.getValue();
        // Use plain js string search to look for newlines, as `find` always
        // returns a range and is harder to work with
        if (val.search(newline) != -1) {
          // Set needle so it can be replaced
          editor.find(newline);
          editor.replaceAll('');
        }
      }
    };
  }


  /* Set up two dropdowns that aid user in inserting snippets for CB objects
   * and attributes, such as "{{ server.hostname }}".
   */
  function setupSnippets(editor) {
    var selId1 = '#' + editor.id + '-objects';
    var selId2 = '#' + editor.id + '-attrs';
    var $objects = $(selId1);
    var $attrs = $(selId2);

    c2.combobox.chain(
      selId1, selId2,
      // URL to fetch options for 2nd select
      '/context_attrs_for_object/<%=value%>/',
      // Selectize 1 options
      {
        allowEmptyOption: false,
        // By default, plugins includes selectable placeholder but we don't
        // want that here
        plugins: {}
      },
      // Selectize 2 options
      {
        valueField: 'value',
        labelField: 'label'
      }
    );

    $attrs.on('change', function() {
      if (editor.oneLineMode) {
        // Prevent infinite loop from change handler
        editor.getSession().off('change');
      }

      // The 2nd dropdown actually contains the full snippet
      editor.insertSnippet($attrs.val());

      if (editor.oneLineMode) {
        // Restore change handler
        editor.getSession().on('change', replaceNewlines);
      }

      // Reset both dropdowns to empty values and remove options from the 2nd
      $objects[0].selectize.setValue('');
      var attrSelectize = $attrs[0].selectize;
      attrSelectize.setValue('');
      attrSelectize.disable();
      attrSelectize.clearOptions();

      // Take focus off dropdown and back where cursor is
      editor.focus();
      // Let user type; without this the text is selected and cursor won't move
      editor.setReadOnly(false);
    });
  }

  /* Set up a dropdown that aid user in inserting snippets for previous steps
  *  of the blueprint, such as {{ outputs.my_plugin.(add your key name here) }}.
  */
  function setupOutputs(editor) {
    var selId = '#' + editor.id + '-outputs';
    var $attrs = $(selId);

    $attrs.on('change', function() {
      if (editor.oneLineMode) {
        // Prevent infinite loop from change handler
        editor.getSession().off('change');
      }

      editor.insertSnippet($attrs[0].value);

      if (editor.oneLineMode) {
        // Restore change handler
        editor.getSession().on('change', replaceNewlines);
      }

      // Reset dropdown to empty value
      $attrs[0].value = '';
      // Take focus off dropdown and back where cursor is
      editor.focus();
      // Let user type; without this the text is selected and cursor won't move
      editor.setReadOnly(false);
    });
  }

  function setupLanguages(editor, language, defaultToPowershell, pluginDefaultLanguage) {
    language = language || 'ace/mode/python';
    defaultToPowershell = defaultToPowershell || false;
    pluginDefaultLanguage = pluginDefaultLanguage || false;
    editor.getSession().setMode(language);

    var otherLangs = document.getElementById(editor.id + '-other-langs');
    var langSelect = document.getElementById(editor.id + '-language');

    otherLangs.addEventListener('change', function() { buildLangSelect(editor, langSelect, otherLangs); });
    langSelect.addEventListener('change', function() { updateSelects(editor, langSelect); }, true);

    setLangs(langSelect, defaultLangs, pluginDefaultLanguage);

    // Make Powershell the default selection if requested (AKA if Windows)
    if (editor.getValue() === "") {
      // Set "shebang" and move cursor to end of it (2nd arg to setValue)
      if (defaultToPowershell) {
        setSelectOption(langSelect, 'powershell');
        editor.setValue(powershellHeader, 1);
      } else {
        // Provide a default for the user's shebang for new scripts.
        editor.setValue("#!/usr/bin/env bash\n", 1);
      }
    }
  }


  function updateSelects(editor, select) {
    var language = "ace/mode/" + select.value;
    var cursorPos, firstLine;

    // Do nothing with shebang if the editor already had code in it.
    if (editor.getValue() !== '') {
      var header = "";
      if (header) {
        cursorPos = editor.getCursorPosition();
        firstLine = editor.getValue().split("\n")[0];
        var first_line_header = firstLine.startsWith("#!") || firstLine.startsWith(powershellHeader);
        if (first_line_header) {
          editor.moveCursorToPosition({row: 0, column: 0});
          editor.removeToLineEnd();
          editor.moveCursorToPosition({row: 0, column: 0});
          editor.insert(header);
        } else {
          editor.moveCursorToPosition({row: 0, column: 0});
          editor.insert(header + "\n");
        }
        editor.moveCursorToPosition(cursorPos);
      }

    }
    editor.getSession().setMode(language);
    logger.debug("Set editor " + editor.id + " mode to: "+language);
  }

  function removeSelectOptions(elem) {
    var i;
    for(i=elem.options.length-1;i>=0;i--) {
      elem.remove(i);
    }
  }

  function setSelectOption(elem, val) {
    var opts = elem.options;
    for(var opt, j = 0; opt = opts[j]; j++) {
      if(opt.value == val) {
        elem.selectedIndex = j;
        break;
      }
    }
  }

  function setLangs(elem, langs, pluginDefaultLanguage) {
    var oldLen = elem.length;
    var lang, lastSelected;

    if (oldLen) {
      lastSelected = elem.value;
      removeSelectOptions(elem);
    }
    for (lang in langs) {
      var option = document.createElement("option");
      option.text = langs[lang].caption;
      option.value = langs[lang].name;
      if (langs[lang].name === pluginDefaultLanguage) option.selected = 'selected';
      elem.add(option);
    }
    if (oldLen) {
      setSelectOption(elem, lastSelected);
    }
  }

  function buildLangSelect(editor, select, checkbox, pluginDefaultLanguage) {
    if (checkbox.checked === true) {
      setLangs(select, modelist.modes, pluginDefaultLanguage);
    } else {
      setLangs(select, defaultLangs, pluginDefaultLanguage);
    }
    updateSelects(editor, select);
  }

  function toggleOotbCode(container_id) {
    var $container = $(container_id);
    var $label = $container.find('.show-or-hide');
    var $current_code_label = $container.find('.current-code-label');
    var $ootb_code_panel = $container.find('.ootb-code-panel');

    // Change the link wording
    // make the OOTB code show/hide and be pretty,
    // make a the label for the current code show/hide
    if ($label.text() === 'Show') {
      $label.text('Hide');
      $ootb_code_panel.show();
      $current_code_label.show()
    } else {
      $label.text('Show');
      $ootb_code_panel.hide();
      $current_code_label.hide()
    }
  }

  function autoHeightAceInModal(modalId) {
    var modalId = '#'+ (modalId || 'dialog-modal')
    var $modal = $(modalId);

    // For when a modal is already open and content (with the ace editor) is
    // swapped into it without a fresh show()/'shown.bs.modal' event coming.
    if ($modal.hasClass('show')) {
      calcAndSetHeight();
    }

    // For when a modal is just being opened to trigger after opening.
    // #dialog-modal is a single persistent element reused for every dialog
    // on the page, and this function re-runs on every dialog open, so the
    // listener is namespaced and rebound (not stacked) here to prevent compounding mutations
    $modal.off('shown.bs.modal.aceAutoHeight').on('shown.bs.modal.aceAutoHeight', function() {
      calcAndSetHeight();
    });

    function calcAndSetHeight() {
      var $modalDialog = $modal.find(".modal-dialog");
      var $aceEditor = $modalDialog.find(".ace_editor").not(".ace-one-line");
      if (!$aceEditor.length) {
        return;
      }
      // Clear any calc() this function previously applied before measuring,
      // so repeated calls always measure the editor's natural size
      $aceEditor.css({ "height": "", "min-height": "" });
      var newHeight = Math.max(0, $modalDialog.height() - $aceEditor.height());
      $aceEditor.css({
        "height": "calc(100vh - " + newHeight + "px - 4rem)",
        "min-height": "12rem",
      });

      // Ace cannot compute dimensions if it was initialized while the modal was
      // still hidden or mid-transition. The editor is told to recompute them here,
      // once the modal is fully shown and the container has real dimensions.
      $aceEditor.each(function() {
        var editor = this.env && this.env.editor;
        if (editor) {
          editor.resize(true);
          editor.renderer.updateFull(true);
        }
      });
    }
  }

  c2[__module__] = {
    init: init,
    initializeAceInPanel: initializeAceInPanel,
    autoHeightAceInModal: autoHeightAceInModal,
    saveUpdatedCode: saveUpdatedCode,
    addCompleter: langTools.addCompleter,
    setupLanguages: setupLanguages,
    setupSnippets: setupSnippets,
    setupOutputs: setupOutputs,
    toggleOotbCode: toggleOotbCode
  };

})('ace');
